import { render } from "./zhiyenews.vue?vue&type=template&id=6a0224b4&scoped=true"
import script from "./zhiyenews.vue?vue&type=script&lang=js"
export * from "./zhiyenews.vue?vue&type=script&lang=js"

import "./zhiyenews.vue?vue&type=style&index=0&id=6a0224b4&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0224b4"]])

export default __exports__